import { Component } from '@angular/core';

// Renders the "(Required)" hint shown next to the label of a mandatory form field.
// Kept as a component so the string is extracted into a single translation unit.
@Component({
  selector: 'app-required-marker',
  imports: [],
  templateUrl: './required-marker.component.html',
  styleUrl: './required-marker.component.css',
})
export class RequiredMarkerComponent { }
